// import styles from "./HotelCard.module.css";
// import { useNavigate } from "react-router-dom";

// export default function HotelCard({ hotel }) {

//   const navigate = useNavigate();

//   const largestCapacity =
//     hotel.ballrooms?.reduce((max, ballroom) => {
//       const capacity =
//         ballroom.capacities?.reduce(
//           (m, c) => Math.max(m, c.capacity || 0),
//           0
//         ) || 0;

//       return Math.max(max, capacity);
//     }, 0) || 0;

//   return (
//     <div className={styles.card}>

//       <img
//         src={hotel.featured_image}
//         alt={hotel.name}
//         className={styles.image}
//       />

//       <div className={styles.content}>

//         <h3>{hotel.name}</h3>

//         <p className={styles.location}>
//           {hotel.city}, {hotel.state}
//         </p>

//         {/* <div className={styles.info}>

//           <div>
//             <span>⭐</span>
//             <strong>{hotel.star_rating}</strong>
//           </div>

//           <div>
//             <span>🏛</span>
//             <strong>{hotel.ballrooms?.length || 0}</strong>
//             <small> Ballrooms</small>
//           </div>

//           <div>
//             <span>👥</span>
//             <strong>{largestCapacity}</strong>
//             <small> Guests</small>
//           </div>

//         </div> */}
// {/* <button
//   className={styles.button}
//   onClick={() =>
//     window.open(`/venue-planner/hotel/${hotel.slug}`, "_blank")
//   }
// >
//   View Ballrooms
// </button> */}
//      <button
//   className={styles.button}
//   onClick={() => navigate(`/venue-planner/hotel/${hotel.slug}`)}
// >
//   View Hotel & Ballrooms
// </button>
//  </div>

//     </div>
//   );
// }

import styles from "./HotelCard.module.css";
import { useNavigate } from "react-router-dom";

export default function HotelCard({ hotel }) {

  const navigate = useNavigate();

  const largestCapacity =
    hotel.ballrooms?.reduce((max, ballroom) => {
      const capacity =
        ballroom.capacities?.reduce(
          (m, c) => Math.max(m, c.capacity || 0),
          0
        ) || 0;

      return Math.max(max, capacity);
    }, 0) || 0;

  return (
    <div className={styles.card}>

      <img
        src={hotel.featured_image}
        alt={hotel.name}
        className={styles.image}
      />

      <div className={styles.content}>

        <h3>{hotel.name}</h3>

        <p className={styles.location}>
          {hotel.city}, {hotel.state}
        </p>

     <button
  className={styles.button}
  // onClick={() => navigate(`/venue-planner/hotel/${hotel.slug}`)}
  onClick={() =>
  navigate(`/venue-planner/hotel/${hotel.slug}`, {
    state: {
      from: `${window.location.pathname}${window.location.search}${window.location.hash}`,
    },
  })
}
>
  View Hotel & Ballrooms
</button>
 </div>

    </div>
  );
}